export default __webpack_public_path__ + "static/media/python.56dbbd2d.png";